const TermAndConditions = () => {
  return (
    <div className="bg-white rounded-xl drop-shadow-xl lg:my-[80px] lg:px-[200px] py-[100px] px-[20px] lg:rounded-[20px] z-0">
      <div className="flex flex-col items-center space-y-14 text-lg">
        <div className="font-bold text-3xl">Booking Term & Conditions</div>
        <div className="flex flex-col justify-start items-start space-y-12 text-justify">
          <div className="flex  max-w-[700px]">
            The following Terms and Conditions apply to all bookings made on
            this website. Please take a moment to read them before making a
            Booking. In these Terms and Conditions, the following definitions
            apply:
          </div>
          <div className="max-w-[700px] space-y-5">
            <div className="font-semibold text-regal-blue">DEFINITIONS</div>
            <div>
              “Airport Shuttle Service”, "Ground Transport Concierge", GTC,
              “we”, “us”, “our” means Woodlands Transport Service Pte Ltd, a
              private company that is authorised by Changi Airport Group to
              operate Shuttle Bus and Private Charter for transfer between
              Changi International Airport Terminals and any hotels.
            </div>
            <div>“Customer” means the person who pays for the Booking.</div>
            <div>
              “Passengers” means all passengers named and unnamed on the
              Booking.
            </div>
            <div>
              “You” and “your” means any customer, including all passengers (or
              any of them as applicable) named on a Booking.
            </div>
            <div>
              “The “Ground Transport Desk / Counter” place where transport
              service can be redeemed or made and that will perform the
              transfer.
            </div>
            <div>
              “Booking” means the booking for transfer services made with us.
            </div>
            <div>
              “Transfer service” means any service provided by us for the
              carriage of{" "}
            </div>
            <div>
              passengers by road and includes any other service provided by us
              relating to or incidental to that carriage.
            </div>
            <div>
              “Transfer Voucher”, “Booking Voucher”, “Voucher” means the written
              confirmation of the Booking we will send to you by email.
            </div>
            <div>
              “Contract” means the Booking and these Terms, and any other terms
              and conditions stated to apply to the Booking.
            </div>
            <div>“Terms” means these Terms and Conditions.</div>
            <div>
              “Website”, “Websites” means www.cityshuttle.com.sg or any other
              website owned or operated by us.
            </div>
            <div>
              On making the booking, the passenger is fully and exclusively
              responsible for the accuracy of all the information that has to be
              given. If it proves to be incorrect, this could lead to the
              cancellation of the booking by GTC.
            </div>
            <div>
              Customers are not allowed to cancel the services requested or
              contracted at any time once booking is made.
            </div>
            <div>
              There will not be any refund or exchange after payment is made.
            </div>
            <div>
              15mins grace period from booked time. No refund will be given
              after 15mins and passenger will be considered as no show.
            </div>
            <div>
              We reserve the right to cancel the reservation for whatsoever
              reason.
            </div>
            <div>
              n this case you will get the full amount refunded. Service
              provider reserves the right to withhold the reason or
              cancellation.
            </div>
            <div>
              Available 365 days - 24 / 7 hours from Changi International
              Airport.
            </div>
            <div className="ml-5">
              Terminal 1, Arrival Hall B1 - Ground Transport Concierge next to
              Taxi Queue
            </div>
            <div className="ml-5">
              Terminal 3, Arrival Hall L1 - Ground Transport Concierge near to
              Coach Stand Exit
            </div>
            <div>
              Passenger is required to present a copy of the email confirmation
              received, printed or in digital format to our counter for service
              redemption.
            </div>
            <div>
              Services booked are strictly limited to Airport to Hotel or any
              destination in Singapore except Tuas and Tuas South. Entry to
              Sentosa Island may be subject to entry charges. No extra stop or
              mid stop in between shall be accepted.
            </div>
            <div>
              We shall be indemnified against all losses of the passengers
              arising from the use of this service. We will exercise every
              safety precaution; however, the company will not be held
              responsible for any personal injury or mishap that may occur
              during the duration of the ride.
            </div>
            <div>
              We will not be held liable for any missed flights. It is the sole
              responsibility of the customer to ensure that they arrive at the
              airport in time for their flight. Schedule is subjected to traffic
              conditions. During peak hours, the travelling and waiting time may
              be longer than usual.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TermAndConditions;
